
$models.search = {
	
	getList : function($params, $callback) {
		if ($models.search.currentGetListAjaxRequest) {
			$models.search.currentGetListAjaxRequest.abort();
		}
		$models.search.currentGetListAjaxRequest = $models.all.getDataFromAPI('search.json', $params, $callback, 'Unable to load the search results');
	},
	
	isAjaxRequestInProgress : function() {
		if (!$models.search.currentGetListAjaxRequest) { return false; }
		if ($models.search.currentGetListAjaxRequest.status > 100) { return false; }
		return true;
	}
	
}



// WEBPACK FOOTER //
// ./src/js/models/search.js